import generaldashboard from '@/app/dashboard/router'
import tasksdashboard from '@/app/dashboard-tasks/router'
import tvdashboard from '@/app/dashboard-tv/router'
import configprofileactivitiestv from '@/app/dashboard-tv/config-profile/router'
import dahsboardSlads from '@/app/dashboard-tv/dashboard-slides/router'
import followupbyboardtv from '@/app/dashboard-tv/follow-up-by-board/router'
import boardList from '@/app/board-list/router'
import board from '@/app/board/router'
import company from '@/app/company/router'
import department from '@/app/department/router'
import user from '@/app/user/router'
import profile from '@/app/user-profile/router'
import activityTemplate from '@/app/activity-template/router'
import expirationControl from '@/app/expiration-control/router'
import useractivities from '@/app/user-activities/router'
import companyprofile from '@/app/company-profile/router'
import emailconfiguration from '@/app/email-configuration/router'
import companydocument from '@/app/company-document/router'
import chargedocument from '@/app/charge-document/router'
import installment from '@/app/installment/router'
import companyactivities from '@/app/company-activities/router'
import companytime from '@/app/company-time/router'
import companytemplates from '@/app/company-templates/router'
import usertime from '@/app/user-time/router'
import CompanyGroup from '@/app/company-group/router'
import robotdocuments from '@/app/robot-documents/router'
import storeApp from '@/app/store-apps/router'
// import viewcard from '@/app/board/shared/components/card/router'

export default [
  ...generaldashboard,
  ...tasksdashboard,
  ...tvdashboard,
  ...configprofileactivitiestv,
  ...dahsboardSlads,
  ...followupbyboardtv,
  ...boardList,
  ...board,
  ...company,
  ...department,
  ...user,
  ...profile,
  ...activityTemplate,
  ...expirationControl,
  ...useractivities,
  ...companyprofile,
  ...emailconfiguration,
  ...companydocument,
  ...chargedocument,
  ...installment,
  ...companyactivities,
  ...companytime,
  ...companytemplates,
  ...usertime,
  ...CompanyGroup,
  ...robotdocuments,
  ...storeApp
  // ...viewcard
]
